<template>
  <div
    :style="{
      '--scroll-ratio': scrollRatio,
      '--status-bar-height': $dmbcEnv.statusBarHeight,
    }"
    :class="[
      _[`scrollRatio${scrollRatio}`],
      ($dmbcEnv.wechat || $dmbcEnv.yancheng) && _.wechat,
    ]"
  >
    <div ref="header" :class="_.header">
      <dmbc-base-icon
        v-track="{
          name: '店铺顶部-返回',
          id: `${componentId}-back`,
        }"
        name="back"
        :class="_.icon"
        @click="handleBackClick"
      />
      <div :class="_.tab">
        <div
          v-track="{
            name: '店铺顶部-主页',
            id: `${componentId}-home`,
          }"
          :class="[_.item, tabIndex === 0 && _.active]"
          @click="tabIndex = 0"
        >
          主页
        </div>
        <div
          v-track="{
            name: '店铺顶部-所有商品',
            id: `${componentId}-all`,
          }"
          :class="[_.item, tabIndex === 1 && _.active]"
          @click="tabIndex = 1"
        >
          所有商品
        </div>
      </div>
      <dmbc-base-icon
        name="search"
        :class="_.icon"
        @click="handleSearchClick"
      />
    </div>

    <div :class="_.store">
      <div :class="_.banner">
        <div :class="_.mask"></div>
        <video
          v-if="theme.topBackground.endsWith('.mp4')"
          :src="theme.topBackground"
          muted
          autoplay
          loop
          playsinline
          webkit-playsinline
          :class="_.image"
        />
        <img v-else :src="theme.topBackground" :class="_.image" />
        <!-- <div :class="_.color"></div> -->
      </div>
      <div :class="_.info">
        <img :src="data[0].icon" :class="_.logo" />
        <div :class="_.name">{{ data[0].title }}</div>
        <img
          v-if="data[0].extendData.hasCert"
          v-track="{
            name: '店铺顶部-商家资质',
            id: `${componentId}-cert`,
          }"
          :src="require('./images/商家资质.png')"
          :class="_.cert"
          @click="handleCertClick"
        />
      </div>
    </div>

    <dmbc-resource-list
      v-if="tabIndex === 1"
      :show-search="false"
      :load="handleDataLoad"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { bindEvent, clamp, toArray } from 'vtils'

  export default Vue.extend({
    props: {
      pageElement: {
        type: null,
        default: () => window,
      },
    },

    data: () => {
      return {
        scrollRatio: 0,
        tabIndex: 0,
      }
    },

    watch: {
      tabIndex() {
        if (this.tabIndex === 0) {
          document
            .querySelector('.proxy_STORE_HEAD')
            .classList.remove(this._.hideOtherComponents)

          // 重置 notice-bar 否则会有问题
          toArray(document.querySelectorAll('.van-notice-bar')).forEach(
            noticeBarNode => {
              noticeBarNode?.__vue__?.reset?.()
            },
          )
        } else {
          document
            .querySelector('.proxy_STORE_HEAD')
            .classList.add(this._.hideOtherComponents)
        }
      },
    },

    mounted() {
      this.$nextTick(() => {
        const pageElementNode =
          typeof this.pageElement === 'string'
            ? document.querySelector(this.pageElement)
            : this.pageElement
        const pageHeaderHeight =
          this.$refs.header.getBoundingClientRect().height
        this.$once(
          'hook:beforeDestroy',
          bindEvent(pageElementNode)('scroll', () => {
            const ratio = clamp(
              pageElementNode.scrollY / pageHeaderHeight,
              0,
              1,
            )
            this.scrollRatio = ratio
          }),
        )
      })
    },

    methods: {
      handleBackClick() {
        this.$dmbcBack()
      },

      handleSearchClick() {
        this.$router.push(
          `/diy/search/index?pageType=store&pageId=${this.data[0].id}`,
        )
      },

      handleCertClick() {
        this.$router.push(`/mart/cert?id=${this.data[0].id}`)
      },

      handleDataLoad(payload) {
        return this.$dmbcApi.searchResource({
          ...payload,
          type: 'store',
          id: this.data[0].id,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  .hideOtherComponents {
    ~ * {
      display: none;
    }
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    height: 44px;
    box-sizing: content-box;
    padding: 0 10px;
    padding-top: var(--status-bar-height);
    z-index: 100;
    background-color: rgba(white, var(--scroll-ratio));

    .icon {
      font-size: 20px;
      color: rgba(black, var(--scroll-ratio));
    }

    .tab {
      flex-grow: 1;
      display: flex;
      align-items: baseline;
      justify-content: center;

      .item {
        font-size: 16px;
        color: rgba(black, var(--scroll-ratio));
        line-height: 22px;

        + .item {
          margin-left: 36px;
        }

        &.active {
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
      }
    }
  }

  .store {
    position: relative;
    width: 100%;

    .banner {
      position: relative;
      width: 100%;
      overflow: hidden;
      font-size: 0;

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 130px;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.8) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      }

      .image {
        width: 100%;
      }

      .color {
        width: 100%;
        height: 176px;
        background-color: #16bbbf;
      }
    }

    .info {
      position: absolute;
      left: 12px;
      right: 12px;
      top: calc(52px + var(--status-bar-height));
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.4) 0%,
        rgba(255, 255, 255, 0.1) 100%
      );
      border-radius: 8px;
      backdrop-filter: blur(20px);
      display: flex;
      align-items: center;
      padding: 12px;

      .logo {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 6px;
      }

      .name {
        flex-grow: 1;
        margin-left: 8px;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        line-height: 22px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .cert {
        margin-left: 8px;
        flex-shrink: 0;
        width: 92px;
        height: 28px;
      }
    }
  }

  .wechat {
    .header {
      display: none;
    }

    .banner {
      .mask {
        display: none;
      }
    }
  }

  .scrollRatio0 {
    .header {
      .icon {
        color: white;
      }

      .tab {
        .item {
          color: white;
        }
      }
    }
  }
</style>
